import { useQuery } from '@tanstack/react-query'
import {
  getEffectiveAreas,
  type EffectiveAreaResult,
  type EffectiveAreasResponse,
} from '../../services/ruutsApi/getEffectiveAreas'
import { queryKeys } from './queryKeys'

export type { EffectiveAreaResult, EffectiveAreasResponse }

// The effective areas are computed live from the strata geometry, so they are never
// stale on their own account; the key nests under samplingAreas so a strata mutation
// busts this read too, and the staleTime only caps the recompute cost between visits.
export const useEffectiveAreas = ({ farmId }: { farmId: string | undefined }) =>
  useQuery({
    queryKey: queryKeys.effectiveAreas(farmId),
    queryFn: ({ signal }) => getEffectiveAreas({ farmId: farmId as string, signal }),
    enabled: !!farmId,
    staleTime: 5 * 60_000,
  })
